(() => {
  const KEY = 'pa_favorites';
  const read = () => {
    try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  };
  const write = (list) => {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* storage geblokkeerd */ }
  };
  const has = (h) => read().includes(h);

  const sync = () => {
    const list = read();
    document.querySelectorAll('[data-favorite-handle]').forEach((btn) => {
      const on = list.includes(btn.dataset.favoriteHandle);
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Verwijder uit favorieten' : 'Voeg toe aan favorieten');
    });
    document.querySelectorAll('[data-favorites-count]').forEach((el) => {
      el.hidden = list.length === 0;
      const n = el.querySelector('span');
      if (n) n.textContent = list.length > 99 ? '99+' : String(list.length);
    });
  };

  const toggle = (h) => {
    const list = read();
    const i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(list);
    sync();
    document.dispatchEvent(new CustomEvent('favorites:change', { detail: { handle: h, active: has(h) } }));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-favorite-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.favoriteHandle);
  });

  // Kaarten die later worden toegevoegd (filteren, "meer laden") krijgen automatisch de juiste status.
  let timer;
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(sync, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', (e) => { if (e.key === KEY) { sync(); document.dispatchEvent(new CustomEvent('favorites:external')); } });
  document.addEventListener('DOMContentLoaded', sync);
  sync();

  // Favorietenpagina: toont dezelfde productkaarten als de collectiepagina
  const initPage = () => {
    const root = document.querySelector('[data-favorites-page]');
    if (!root) return;
    const grid = root.querySelector('[data-favorites-grid]');
    const empty = root.querySelector('[data-favorites-empty]');
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const loadCard = async (h) => {
      try {
        const r = await fetch('/products/' + encodeURIComponent(h) + '?view=card');
        if (!r.ok) return '';
        const html = (await r.text()).trim();
        return html ? '<div class="favorites-item" data-card-handle="' + esc(h) + '">' + html + '</div>' : '';
      } catch (e) { return ''; }
    };

    const render = async () => {
      const cards = await Promise.all(read().map(loadCard));
      grid.innerHTML = cards.join('');
      empty.hidden = grid.children.length > 0;
      sync();
    };

    // Verwijderen op de favorietenpagina haalt de kaart direct weg.
    document.addEventListener('favorites:change', (e) => {
      if (!e.detail.active) {
        const card = grid.querySelector('[data-card-handle="' + CSS.escape(e.detail.handle) + '"]');
        if (card) card.remove();
        empty.hidden = grid.children.length > 0;
      }
    });
    document.addEventListener('favorites:external', render);
    render();
  };
  document.addEventListener('DOMContentLoaded', initPage);

  // Sticky winkelwagenbalk: kleuren van het product tonen en koppelen aan de kleurkeuze op de pagina
  const initStickySwatches = () => {
    const host = document.querySelector('[data-sticky-swatches]');
    if (!host) return;
    const colorFieldset = () => [...document.querySelectorAll('product-selector fieldset')]
      .find((f) => /^(kleur|color|colour)$/i.test(f.getAttribute('data-option-name') || ''));
    const build = () => {
      const fs = colorFieldset();
      const items = fs ? [...fs.querySelectorAll('.product-options__item--swatch')] : [];
      host.innerHTML = '';
      host.hidden = items.length < 1;
      items.forEach((it) => {
        const inp = it.querySelector('input');
        if (!inp) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sticky-swatch' + (inp.checked ? ' is-selected' : '') + (inp.disabled ? ' is-unavailable' : '');
        b.style.setProperty('--swatch-background', it.style.getPropertyValue('--swatch-background') || 'transparent');
        b.title = inp.value;
        b.setAttribute('aria-label', inp.value);
        b.setAttribute('aria-pressed', inp.checked ? 'true' : 'false');
        b.addEventListener('click', () => inp.click());
        host.appendChild(b);
      });
    };
    let t;
    const later = () => { clearTimeout(t); t = setTimeout(build, 120); };
    build();
    document.addEventListener('change', later);
    const ps = document.querySelector('product-selector');
    if (ps) new MutationObserver(later).observe(ps, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
  };
  document.addEventListener('DOMContentLoaded', initStickySwatches);

  // "Terug"-balk onder het menu, over de bovenkant van de foto
  const initBackBar = () => {
    const bar = document.querySelector('[data-back-bar]');
    if (!bar) return;
    const link = bar.querySelector('[data-back-link]');
    const header = document.querySelector('.header');
    const setHeaderHeight = () => {
      if (header) document.documentElement.style.setProperty('--pa-header-h', header.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    link.addEventListener('click', (e) => {
      let sameSite = false;
      try { sameSite = document.referrer && new URL(document.referrer).host === location.host; } catch (err) { /* geen verwijzing */ }
      if (sameSite && history.length > 1) { e.preventDefault(); history.back(); }
    });
  };
  document.addEventListener('DOMContentLoaded', initBackBar);
})();
